<template>
  <ContactForm :open="openContactForm" @hide-modal="hideContactForm()" />
  <div class="bg-surface flex justify-center h-fit lg:rounded-lg p-6 mt-4 lg:mt-8 -mx-4 lg:mx-0 text-base">
    <div class="flex gap-6 items-center">
      <div class="shrink-0 border border-foreground rounded-full p-4">
        <ChatBubbleLeftRightIcon class="w-6" />
      </div>
      <div>
        <p class="text-foreground mb-2">{{ $t("If you're stuck we're happy to help you out") }}</p>
        <div class="flex space-x-4 font-semibold text-foreground">
          <button
            class="flex items-center space-x-1 underline hover:no-underline"
            @click.prevent="openContactForm = true">
            <span>{{ $t("Contact us") }}!</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ChatBubbleLeftRightIcon } from "@heroicons/vue/24/solid";
import ContactForm from "@/components/ContactForm.vue";
import { ref } from "vue";

const openContactForm = ref(false);

const hideContactForm = () => {
  openContactForm.value = false;
};
</script>
